import React from 'react';
import PropTypes from 'prop-types';

export default function ChevronRightIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 11 7" {...rest}>
      <polygon
        fill={color}
        points="9.316 0 5.273 4.066 1.23 0 0 1.237 5.273 6.541 10.547 1.237"
        transform="rotate(-90 5.274 3.27)"
      />
    </svg>
  );
}

ChevronRightIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

ChevronRightIcon.defaultProps = {
  size: 15,
  color: '#000',
};
